import React, { Component } from 'react';
import EmojiChip from './EmojiChip';

class NewMessage extends Component {

    state = {
        message: '',
    }

    inputChangeHandler = (event) => {
        const message = event.target.value;
        this.setState({ message: message });
        if (this.props.emojiRecommendations && this.props.emojiRecommendations !== []) this.props.cleared();
    }

    sendMessageHandler = (event) => {
        event.preventDefault();
        this.props.send(this.state.message);
        this.setState({ message: '' });
    }

    emojiClickHandler = (event, emoji) => {
        event.preventDefault();
        this.setState(prevState => { return { message: prevState.message + emoji } });
        this.props.cleared();
    }

    render() {
        return (
            <form className="new-message" >
                <input className="new-message__input"
                    type="text"
                    disabled={this.props.disabled}
                    placeholder="Enter your message"
                    value={this.state.message}
                    onChange={this.inputChangeHandler} />
                <EmojiChip
                    disabled={this.props.disabled || !this.state.message}
                    recommendations={this.props.emojiRecommendations}
                    clicked={(event) => this.props.clicked(event, this.state.message)}
                    emojiClicked={(event, emoji) => this.emojiClickHandler(event, emoji)}
                />
                <button className="new-message__button"
                    type="submit"
                    disabled={this.props.disabled || !this.state.message}
                    onClick={this.sendMessageHandler}>
                    <i className="fa fa-paper-plane" aria-hidden="true"></i>
                </button>

            </form>
        );
    }
}

export default NewMessage;